import React from 'react'
import { Box, FormControlLabel, RadioGroup, Typography } from '@mui/material'

import { Radio } from '@/components/base/radio'

import { WPCF7Form } from '@/types'

export type RadioFieldProps = {
  field: WPCF7Form['form'][0]
  formik: any
}

const RadioField = ({ field, formik }: RadioFieldProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(`input_${field.id}`, event.target.value)
  }

  return (
    <>
      {field.label && field.labelPlacement !== 'hidden_label' && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: 'block',
            mb: 2,
            ...(formik.submitCount > 0 &&
              formik.errors[`input_${field.id}`] !== undefined &&
              formik.touched[`input_${field.id}`] !== undefined && {
                color: 'error.main'
              })
          }}
        >
          {field.label}
          {field.isRequired ? ' *' : ''}
        </Typography>
      )}
      <RadioGroup
        value={formik.values[`input_${field.id}`] || ''}
        onChange={handleChange}
        sx={{
          display: 'flex',
          flexDirection: field.cssClass === 'radiogroup-row' ? 'row' : 'column',
          columnGap: 4,
          ...(formik.isSubmitting && {
            pointerEvents: 'none',
            opacity: 0.4
          })
        }}
      >
        {field.choices?.map((choice) => (
          <FormControlLabel
            key={choice.value}
            value={choice.value}
            control={<Radio />}
            label={
              <Box>
                <Typography
                  variant="textRegular"
                  color="text.secondaryContrastText"
                  sx={{
                    ...(formik.submitCount > 0 &&
                      formik.errors[`input_${field.id}`] !== undefined &&
                      formik.touched[`input_${field.id}`] !== undefined && {
                        color: 'error.main'
                      })
                  }}
                >
                  {choice.text}
                </Typography>
              </Box>
            }
            sx={{
              alignItems: 'center',
              ml: '-9px'
            }}
          />
        ))}
      </RadioGroup>
      {formik.submitCount > 0 &&
        formik.touched[`input_${field.id}`] &&
        formik.errors[`input_${field.id}`] && (
          <Typography variant="caption" color="error" sx={{ mt: 1 }}>
            {String(formik.errors[`input_${field.id}`])}
          </Typography>
        )}
    </>
  )
}

export default RadioField
